import React from "react";
import { navHeight } from "src/stores/presentation-store";

export interface StickyTopProps {
  children: any;
}
export const StickyTop: React.FunctionComponent<StickyTopProps> = (props: StickyTopProps) => {
  const contentRef = React.useRef(null);
  let sub: any;
  React.useEffect(() => {
    sub = navHeight.subscribe((h) => {
      contentRef.current.style.top = `${h}px`;
    });
    return (): void => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, []);
  return (
    <div ref={contentRef} className="sticky-top">
      {props.children}
    </div>
  );
};
